import Component from 'vue-class-component';
import Vue from 'vue';
import {Fragment} from 'vue-fragment';
import LoginWorldWide from '../LoginWorldWide/LoginWorldWide.vue';

@Component({
  props: {
    myDataUrl: String,
    logoutUrl: String,
    loginUrl: String,
    registerUrl: String,
    myAccount: String,
    firstName: String,
    lastName: String,
    label: Object,
    state: String,
  },
  components: {Fragment, LoginWorldWide},
})
export default class LoginExtranet extends Vue {
}
